import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import Header from '../Shared/Header';
import './PricingPage.css'; // Reusing some pricing styles

const PaymentStatus = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('loading'); // loading, success, failed, error
    const [details, setDetails] = useState(null);
    const orderId = searchParams.get('order_id');

    useEffect(() => {
        const verifyPayment = async () => {
            if (!orderId) {
                setStatus('error');
                return;
            }

            try {
                const res = await fetch(`${API_BASE_URL}verify_cashfree_payment.php?order_id=${orderId}`, { credentials: 'include' });
                const data = await res.json();

                if (data.status === 'success') {
                    if (data.order_status === 'SUCCESS') {
                        setStatus('success');
                        // Immediate sync for localStorage
                        const userStr = localStorage.getItem('user');
                        if (userStr) {
                            const user = JSON.parse(userStr);
                            if (data.cf_details.plan_name === 'Premium Plan') {
                                user.role = 'premium';
                            }
                            localStorage.setItem('user', JSON.stringify(user));
                        }
                    } else if (data.order_status === 'FAILED') {
                        setStatus('failed');
                    } else {
                        setStatus('pending');
                    }
                    setDetails(data.cf_details);
                } else {
                    setStatus('error');
                }
            } catch (err) {
                console.error("Verification error:", err);
                setStatus('error');
            }
        };

        verifyPayment();
    }, [orderId]);

    return (
        <div className="pricing-page">
            <Header />
            <main className="container" style={{ paddingTop: '100px', textAlign: 'center', minHeight: '60vh' }}>
                <div className="status-card glass-card" style={{ padding: '3rem', borderRadius: '24px', maxWidth: '500px', margin: '0 auto' }}>
                    {status === 'loading' && (
                        <div className="loading-state">
                            <div className="spinner"></div>
                            <h2>Verifying Payment...</h2>
                            <p>Please do not refresh or close this page.</p>
                        </div>
                    )}

                    {status === 'success' && (
                        <div className="success-state">
                            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✅</div>
                            <h2 className="gradient-text">Payment Successful!</h2>
                            <p>Your plan has been updated successfully. You can now access your content.</p>
                            <div style={{ margin: '2rem 0', padding: '1rem', background: 'rgba(255,255,255,0.05)', borderRadius: '12px', textAlign: 'left' }}>
                                <p><strong>Order ID:</strong> {orderId}</p>
                                <p><strong>Amount:</strong> ₹{details?.order_amount}</p>
                            </div>
                            <Link to="/dashboard" className="btn btn-primary">Go to Dashboard</Link>
                        </div>
                    )}

                    {status === 'failed' && (
                        <div className="failed-state">
                            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>❌</div>
                            <h2 style={{ color: '#ff4444' }}>Payment Failed</h2>
                            <p>Unfortunately, the transaction could not be completed.</p>
                            <Link to="/pricing" className="btn btn-secondary" style={{ marginTop: '2rem' }}>Try Again</Link>
                        </div>
                    )}

                    {status === 'pending' && (
                        <div className="pending-state">
                            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>⏳</div>
                            <h2>Payment Pending</h2>
                            <p>Your payment is being processed. It might take a few minutes to reflect.</p>
                            <Link to="/dashboard" className="btn btn-primary" style={{ marginTop: '2rem' }}>Check Dashboard Later</Link>
                        </div>
                    )}

                    {status === 'error' && (
                        <div className="error-state">
                            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>⚠️</div>
                            <h2>Something went wrong</h2>
                            <p>We couldn't verify your payment. Please contact support if the amount was deducted.</p>
                            <Link to="/" className="btn btn-secondary" style={{ marginTop: '2rem' }}>Back to Home</Link>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
};

export default PaymentStatus;
